import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_AccountIssuedInvoices_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AccountIssuedInvoices_Modules_ApiEnum {
    'results' = 'results',
}

export enum Config_AccountIssuedInvoices_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AccountIssuedInvoices_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AccountIssuedInvoices_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_AccountIssuedInvoices_ApiInterface
    extends ConfigDataInterface<
        Config_AccountIssuedInvoices_Modules_ApiEnum,
        Config_AccountIssuedInvoices_ActionsMenu_ApiEnum,
        Config_AccountIssuedInvoices_ActionsOther_ApiEnum,
        Config_AccountIssuedInvoices_PageMenu_ApiEnum,
        Config_AccountIssuedInvoices_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
